<template>
    <div>
        <div v-if="anio3 >= 2008">
            <h5 class="subtitulo2 mt-5">Normatividad Contable y Financiera {{anio3}}</h5> 

                <!-- Acordeon -->
                <div class="accordion mt-4" id="accordionExample">
                    <div class="card">
                        <div class="card-header" id="headingOne">
                        <h2 class="mb-0">
                            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                            <span>Normatividad Contable y Financiera</span>
                            <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                            </button>
                        </h2>
                        </div>

                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body">                                     
                                <UL>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/Presentacion.pdf'" target="_blank">Presentación</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/I-Normas.pdf'" target="_blank">Título I - Normas Generales</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/II-Recaudacion.pdf'" target="_blank">Título II - Subsistema de Recaudación</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/III-Fondos.pdf'" target="_blank">Título III - Subsistema de Fondos Estatales</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/IV-Egresos.pdf'" target="_blank">Título IV - Subsistema de Egresos</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/V-Deuda.pdf'" target="_blank">Título V - Subsistema de Deuda Pública</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/VI-Entidades.pdf'" target="_blank">Título VI - Entidades Paraestatales</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/VII-Fideicomisos.pdf'" target="_blank">Título VII - Fideicomisos</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/VIII-Organismos.pdf'" target="_blank">Título VIII - Organismos Autónomos</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Normatividad/Transitorios.pdf'" target="_blank">Transitorios</A> </LI>
                                    <LI v-if="anio3 == 2008"><A :href="urlServe + ruta + anio3 + '/Normatividad/Portada.pdf'" target="_blank">Portadas</A> </LI>
                                    <LI v-else>Portadas</LI>
                                </UL>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header" id="headingTwo">
                        <h2 class="mb-0">
                            <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style="display:flex; justify-content:space-between;">
                            <span>Anexos</span>
                            <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                            </button>
                        </h2>
                        </div>
                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                            <div class="card-body">                                 
                                <UL>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Anexos/III-Fondos.pdf'" target="_blank">Título III - Subsistema de Fondos Estatales</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Anexos/IV-Egresos.pdf'" target="_blank">Título IV - Subsistema de Egresos</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Anexos/VI-Entidades.pdf'" target="_blank">Título VI - Entidades Paraestatales</A> </LI>
                                    <span v-if="anio3 == 2008">    
                                        <LI><A :href="urlServe + ruta + anio3 + '/Anexos/VII-Fideicomisos.pdf'" target="_blank">Título VII - Fideicomisos</A> </LI>
                                        <LI><A :href="urlServe + ruta + anio3 + '/Anexos/VIII-Autonomos.pdf'" target="_blank">Título VIII - Organismos Autónomos</A> </LI>
                                    </span>
                                </UL>  
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header" id="headingThree">
                            <h2 class="mb-0">
                                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style="display:flex; justify-content:space-between;">
                                <span>Manual de Contabilidad</span>
                                <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                </button>
                            </h2>
                        </div>
                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                            <div class="card-body">
                                <UL>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Manual/Recaudacion.pdf'" target="_blank">Subsistema de Recaudación</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Manual/Fondos.pdf'" target="_blank">Subsistema de Fondos Estatales</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Manual/Egresos.pdf'" target="_blank">Subsistema de Egresos</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Manual/Deuda.pdf'" target="_blank">Subsistema de Deuda Pública</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Manual/Fideicomisos.pdf'" target="_blank">Fideicomisos <span v-if="anio3 == 2009">Públicos</span> </A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Manual/Organismos.pdf'" target="_blank">Organismos Autónomos</A> </LI>
                                    <LI v-if="anio3 == 2009">Portadas</LI>
                                </UL>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header" id="headingFour">
                            <h2 class="mb-0">
                                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour" style="display:flex; justify-content:space-between;">
                                <span>Formatos de Cuenta Pública</span>
                                <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                </button>
                            </h2>
                        </div>
                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                            <div class="card-body">
                                <UL>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Formatos/Recaudacion.zip'" target="_blank">Subsistema de Recaudación</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Formatos/Fondos.zip'" target="_blank">Subsistema de Fondos Estatales</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Formatos/Egresos.zip'" target="_blank">Subsistema de Egresos</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Formatos/Deuda.zip'" target="_blank">Subsistema de Deuda Pública</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Formatos/Entidades.zip'" target="_blank">Entidades Paraestatales</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Formatos/Fideicomisos.zip'" target="_blank">Fideicomisos Públicos</A> </LI>
                                    <LI><A :href="urlServe + ruta + anio3 + '/Formatos/Organismos.zip'" target="_blank">Organismos Autónomos</A> </LI>
                                </UL>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

    </div>
</template>

<script>
export default {
    data: function(){
        return {
            ruta: 'marco-juridico/Estatal/informacion/Normas/N-contable-financiera/',
        }
    },
    props:{
        anio3: null,
    }
}
</script>

<style scoped>

.card-header { background-color: #fff; }
.btn-link{ color: #474444; }
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }

li{ 
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }


/*  */

    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

   
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        margin-top: 3rem;
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex !important;
        justify-content: flex-end !important;
    }
    .card-width{ width: 90%; }
    
    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around !important; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>
